import * as authActions from "./auth";
import * as invitationActions from "./invitation";
import * as favoriteActions from "./favorite";
import * as lessonActions from "./lesson";
import * as requestStateAction from "./requestState";
import * as subscriptionAction from "./subscription";

export const auth = authActions;
export const invitation = invitationActions;
export const favorite = favoriteActions;
export const lesson = lessonActions;
export const requestState = requestStateAction;
export const subscription = subscriptionAction;
